(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    root.dataset.merlaMotion = 'reduced';
    return;
  }

  const sources = Array.isArray(window.MerlaMotionAssets) ? window.MerlaMotionAssets : [];
  let index = 0;

  const loadNext = () => {
    const file = sources[index];
    index += 1;
    if (!file) return;

    const script = document.createElement('script');
    script.src = file;
    script.async = false;
    script.onload = loadNext;
    script.onerror = () => { root.dataset.merlaMotion = 'unavailable'; };
    document.head.appendChild(script);
  };

  loadNext();
})();
